import React from 'react';

const EventsAppWrapper = ({ children }) => (
  <React.Fragment>
    {children}
  </React.Fragment>
);

export default EventsAppWrapper;
